module.exports = __webpack_public_path__ + "static/media/b1.56555bc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dengyunze/b1.mp3
// module id = ALCZ
// module chunks = 0